export const isMailButtonDisabled = (candidate) => {
  if (!candidate) {
    return true;
  }

  const bgcStatus = candidate.status?.toUpperCase();

  const personalCompleted =
    candidate.statusResponse?.personalInfoStatus?.toUpperCase() ===
    "COMPLETED";

  const addressCompleted =
    candidate.statusResponse?.addressInfoStatus?.toUpperCase() ===
    "COMPLETED";

  const educationCompleted =
    candidate.statusResponse?.educationInfoStatus?.toUpperCase() ===
    "COMPLETED";

  const criminalCompleted =
    candidate.criminalCheckStatus?.toUpperCase() ===
    "COMPLETED";

  const mandatoryChecksCompleted =
    personalCompleted &&
    addressCompleted &&
    educationCompleted &&
    criminalCompleted;

  return !(
    bgcStatus === "WORK_IN_PROGRESS" &&
    mandatoryChecksCompleted
  );
};